export const PENDING = 'تحت المراجعة'
export const ACCEPED = 'تم النشر'
export const ENDED = 'تمت'
export const REJECTED = 'تم الرفض'